import { Icon, IconButton, Menu, MenuItem } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import { getCurrency } from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import {
  complaintDashboard,
  getJiraRequestLog,
} from "../../redux/actions/JiraActions";
import PrimaryTheme from "../../Themes/Primary";
import SimplePopover from "../Logs/LogViews";
import "./location.scss";
import "../Logs/logs.scss";
import { getLocationPerformanceAction } from "../../redux/actions/AgentActions";
export default function Locations() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const dashboard: Dashboard = useSelector(
    (state: Reducers) => state.complaintDashboard
  );
  const locations = useSelector((state: Reducers) => state.getLocation);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [status, setStatus] = React.useState("");
  const [type, setType] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  var d = new Date();
  d.setDate(d.getDate() - 1);
  const [rangeState, setrangeState] = React.useState([
    {
      startDate: d,
      endDate: new Date(),
      key: "selection",
    },
  ]);
  let list: any = locations && locations.data;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;

    dispatch({
      type: "LOADING",
      payload: true,
    });

    //dispatch(getJiraRequestLog(paginationConfig));
  };

  const handleRouteLogDetails = (id: any) => {
    history.push("/location/details/" + id);
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    // dispatch(getJiraRequestLog(paginationConfig));
    // dispatch(complaintDashboard());
  };

  const getColor = (actual: any, totalTerget: any) => {
    if (actual > totalTerget) {
      return "badge-success";
    } else {
      return "badge-danger";
    }
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    if (status !== "") {
      filter.jiraStatus = status;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      //dispatch(getJiraRequestLog(paginationConfig));
    }

    if (searchState.length >= 5) {
      filter.agentPhoneNumber = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: false,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, type, searchState, dispatch]);

  const handleSelect = (date: any) => {
    setrangeState([date.selection]);
  };
  React.useEffect(() => {
    filter.startDate = rangeState[0].startDate;
    filter.endDate = rangeState[0].endDate;
    paginationConfig.whereCondition = JSON.stringify(filter);
    dispatch(getLocationPerformanceAction(paginationConfig));
  }, [dispatch, rangeState]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setStatus("");
    setType("");
    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: false,
    });

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  const getIndividualId = (id: any) => {
    history.push(`/logs/details/${id}`);
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            className="mb-5 log-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Location
          </h1>

          <div className="row mb-5">
            <div className="col-md-12 location__filter__div">
              <Filters
                haschangeWidth="col-md-5"
                hasDate
                ranges={rangeState}
                handleSelect={(item: any) => handleSelect(item)}
              />
            </div>
          </div>

          <div className="row" style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Region</th>
                          <th scope="col">Territory</th>

                          <th scope="col">State</th>
                          <th scope="col">Total TXNs</th>
                          <th scope="col">POS</th>
                          <th scope="col">Transfers</th>
                          <th scope="col">No of Agents</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr
                              key={index}
                              className="text-center"
                              onClick={() =>
                                history.push(
                                  `/location/details/${item.regionId}`
                                )
                              }
                            >
                              <td scope="row" style={{ cursor: "pointer" }}>
                                {getIndexSeed(index)}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.regionName ? item.regionName : "-"}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {" "}
                                {item.territoryName ? item.territoryName : "-"}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.stateName ? item.stateName : "-"}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.transactionCount
                                  ? item.transactionCount
                                  : "-"}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.posActual && item.posTarget ? (
                                  <button
                                    className={getColor(
                                      item.posActual,
                                      item.posTarget
                                    )}
                                    style={{
                                      border: "none",
                                      borderRadius: "26px",
                                      padding: "5px 10px 5px 10px",
                                      fontSize: "12px",
                                      fontWeight: 300,
                                    }}
                                  >
                                    {" "}
                                    {item.posActual + "/" + item.posTarget}
                                  </button>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.transferActual && item.transferTarget ? (
                                  <button
                                    className={getColor(
                                      item.transferActual,
                                      item.transferTarget
                                    )}
                                    style={{
                                      border: "none",
                                      borderRadius: "26px",
                                      padding: "5px 10px 5px 10px",
                                      fontSize: "12px",
                                      fontWeight: 300,
                                    }}
                                  >
                                    {" "}
                                    {item.transferActual +
                                      "/" +
                                      item.transferTarget}
                                  </button>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td style={{ cursor: "pointer" }}>
                                {item.totalAgent ? item.totalAgent : "-"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {locations.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={
                          locations.totalItemCount && locations.totalItemCount
                        }
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

interface Dashboard {
  numberOfComplaints?: any;
  pendingComplaints?: any;
  resolvedComplaints?: any;
}
